import React from "react";
import { H2, P, InputContainer, LabelContainer } from "../../styles";
import Button from "../../components/Button/Button";
import { useTranslation } from "react-i18next";
import NvidiaContainer from "../../hoc/NvidiaContainer";
import { ButtonsContainer } from "../../components/Button/styles";

const Account = ({ email, displayName, locale }) => {
  const { t } = useTranslation();
  const navigateToIdp = () => {
    location.href = `${
      locale === "zh-cn" ? JARVIS_PROFILE_CN : JARVIS_PROFILE
    }?login_hint=${encodeURIComponent(email)}`;
  };
  const navigateToHelp = () => {
    location.href = `${locale === "zh-cn" ? JARVIS_HELP_CN : JARVIS_HELP}`;
  };
  return (
    <NvidiaContainer>
      <H2>{t("Account")}</H2>
      <P>{t("Change your personal info and linked accounts")}</P>
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        <LabelContainer>{t("Display name")}</LabelContainer>
        <InputContainer>{displayName}</InputContainer>
      </div>
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        <LabelContainer>{t("Email")}</LabelContainer>
        <InputContainer>{email}</InputContainer>
      </div>
      <ButtonsContainer>
        <Button label={t("Edit your account")} clickHandler={navigateToIdp} />
        <Button label={t("Help")} clickHandler={navigateToHelp} theme="alt" />
      </ButtonsContainer>
    </NvidiaContainer>
  );
};
export default Account;
